import ProductReviews from './ProductReviews';

export default ProductReviews;
